import './SliderInput.scss';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Slider } from '@mui/joy';
import { ReactElement, ReactNode } from 'react';
import { RowLayout } from '../../../../modules/common/layouts/rowLayout/RowLayout';

interface ISliderInputProps {
  icon: IconProp;
  label: string;
  value: number;
  min: number;
  max: number;
  step?: number;
  renderValue: (value: number) => ReactNode;
  onChange: (value: number) => void;
}

export const SliderInput = ({ icon, label, renderValue, onChange, value, ...rest }: ISliderInputProps): ReactElement => {
  return (
    <div className='slider-input'>
      <RowLayout
        size='sm'
        spread
      >
        <RowLayout size='sm'>
          <FontAwesomeIcon icon={icon} /> {label}
        </RowLayout>
        <div>{renderValue(value)}</div>
      </RowLayout>
      <Slider
        {...rest}
        value={value}
        onChange={(_, v) => {
          onChange(v as number);
        }}
      />
    </div>
  );
};
